import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-laptop-icon',
    templateUrl: './laptop-icon.component.html'
})
export class LaptopIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 32;
    }
}
